'use client';

import { createContext } from 'react';

interface CurrentUserContextValue {
  currentUserId: string | null | undefined;
  isImpersonating: boolean;
  isSuperuser: boolean;
}

export const CurrentUserContext = createContext<CurrentUserContextValue>({
  currentUserId: null,
  isImpersonating: false,
  isSuperuser: false,
});

export function CurrentUserProvider({
  value,
  children,
}: {
  value: CurrentUserContextValue;
  children: React.ReactNode;
}) {
  return (
    <CurrentUserContext.Provider value={value}>
      {children}
    </CurrentUserContext.Provider>
  );
}
